import { useCoreConfig } from '../composables/useCoreConfig'
import { isAbsoluteUrl, lookupPublicAsset } from './publicAssetUrl'

export function mediaUrl(path: string): string {
    if (!path || isAbsoluteUrl(path) || path.includes('?')) return path

    const fingerprinted = lookupPublicAsset(path)
    if (fingerprinted) return fingerprinted

    const version = useCoreConfig().media?.version

    return version ? `${path}?v=${version}` : path
}
